import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useIntl } from 'react-intl';
import useAuthAPI from '../../../api/auth';
import useAPI from '../../../api';
import { Alert, Paper, Typography } from '@mui/material';
import { useForm, FormProvider } from 'react-hook-form';
import CustomButton from '../../../Components/Inputs/CustomButton';
import InputPassword from '../Components/InputPassword';
import getErrorMessage from '../../../Helpers/Errors/getErrorMessage';
import { useSetAtom } from 'jotai';
import {
  selectedBranchAtom,
  userBranchesAtom,
  userDataAtom,
} from '../../../Atoms';

const ChangePwd = function ChangePwd() {
  const intl = useIntl();
  const AuthAPI = useAuthAPI();
  const API = useAPI();
  const navigate = useNavigate();
  const setSelectedBranch = useSetAtom(selectedBranchAtom);
  const setUserBranches = useSetAtom(userBranchesAtom);
  const setUserData = useSetAtom(userDataAtom);
  const [changePwdError, setChangePwdError] = useState(null);
  const [subtitles, setSubtitles] = useState([
    intl.messages.COMPILE_FIELDS_TO_CHANGE_PASSWORD,
  ]);

  const {
    register, //sends input data
    formState: { errors },
    ...methods
  } = useForm();

  const onChangePassword = () => {
    setSelectedBranch(null);
    setUserBranches(null);
    setUserData(null);
    AuthAPI.logout();
    navigate('/'); //login page
  };

  const onSubmit = (data) => {
    if (data.newPassword === data.confirmPassword) {
      API.changePassword(
        {
          oldPassword: data.oldPassword,
          newPassword: data.newPassword,
        },
        () => onChangePassword(),
        (err) =>
          setChangePwdError(getErrorMessage(err, intl) || intl.messages.ERROR)
      );
    } else {
      setChangePwdError(intl.messages.PASSWORD_MISMATCH);
    }
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <div
          style={{
            width: '100%',
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Paper
            elevation={3}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              p: { xs: '28px', sm: '48px' },
              width: { xs: '92%', sm: 'auto' },
              minWidth: { xs: 0, sm: '600px' },
              maxWidth: '600px',
              borderRadius: '18px',
            }}
          >
            <Typography variant="h4" sx={{ color: 'greys.title' }}>
              {intl.messages.CHANGE_PASSWORD}
            </Typography>
            {subtitles.map((sub, index) => (
              <Typography
                key={sub}
                variant="subtitle1"
                sx={{
                  mb: index === subtitles.length - 1 ? '24px' : null,
                  color: 'greys.title',
                  width: '100%',
                }}
              >
                {sub}
              </Typography>
            ))}
            {changePwdError && (
              <Alert severity="error" sx={{ mb: '16px' }}>
                {changePwdError}
              </Alert>
            )}
            <InputPassword
              label={intl.messages.OLD_PASSWORD}
              register={register}
              name="oldPassword"
              error={errors?.oldPassword}
              fullWidth
            />
            <InputPassword
              label={intl.messages.NEW_PASSWORD}
              register={register}
              name="newPassword"
              error={errors?.newPassword}
              fullWidth
            />
            <InputPassword
              label={intl.messages.CONFIRM_PASSWORD}
              register={register}
              name="confirmPassword"
              error={errors?.confirmPassword}
              fullWidth
              customValidation={(value, formValues) =>
                value !== formValues?.newPassword
                  ? intl.messages.PASSWORD_MISMATCH
                  : true
              }
            />
            <Link
              onClick={() => {
                setSubtitles([intl.messages.COMPILE_FIELDS_TO_CHANGE_PASSWORD]);
              }}
              to={-1}
              style={{
                textDecoration: 'none',
                fontFamily: 'Roboto',
                marginBottom: '10px',
              }}
              tabIndex={-1} //make it unfocusable with tab key
            >
              {intl.messages.BACK}
            </Link>
            <CustomButton
              type="submit"
              styles={{
                mb: '24px',
                height: '50px',
                mt: '8px',
              }}
              label={intl.messages.CHANGE_PASSWORD}
            />
          </Paper>
        </div>
      </form>
    </FormProvider>
  );
};

export default ChangePwd;
